import { Controller } from "stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  static targets = [
    "candidateSelect",
    "residencyDisplay",
    "startInput",
    "endInput",
    "durationOutput",
    "submitButton",
  ];

  connect() {
    this.startPicker = this.buildPicker(this.startInputTarget);
    this.endPicker = this.buildPicker(this.endInputTarget);

    this.boundUpdateResidency = this.updateResidency.bind(this);
    this.boundUpdateDuration = this.updateDuration.bind(this);

    this.candidateSelectTarget.addEventListener("change", this.boundUpdateResidency);
    this.startInputTarget.addEventListener("change", this.boundUpdateDuration);
    this.endInputTarget.addEventListener("change", this.boundUpdateDuration);

    this.updateResidency();
    this.updateDuration();
  }

  disconnect() {
    this.candidateSelectTarget.removeEventListener("change", this.boundUpdateResidency);
    this.startInputTarget.removeEventListener("change", this.boundUpdateDuration);
    this.endInputTarget.removeEventListener("change", this.boundUpdateDuration);

    if (this.startPicker) this.startPicker.destroy();
    if (this.endPicker) this.endPicker.destroy();
  }

  buildPicker(input) {
    return flatpickr(input, {
      enableTime: true,
      time_24hr: true,
      minuteIncrement: 15,
      dateFormat: "Y-m-d\\TH:i",
      allowInput: true,
    });
  }

  updateResidency() {
    const selectedOption =
      this.candidateSelectTarget.options[this.candidateSelectTarget.selectedIndex];
    if (!selectedOption || !selectedOption.value) {
      this.residencyDisplayTarget.value = "";
      return;
    }
    this.residencyDisplayTarget.value =
      selectedOption.getAttribute("data-course-name") ||
      "No active residency course";
  }

  updateDuration() {
    const startValue = this.startInputTarget.value;
    const endValue = this.endInputTarget.value;
    if (!startValue || !endValue) {
      this.durationOutputTarget.textContent = "Duration: --";
      this.durationOutputTarget.classList.remove("preceptor-attendance__hint--danger");
      this.submitButtonTarget.disabled = true;
      return;
    }

    const start = new Date(startValue);
    const end = new Date(endValue);
    const durationMinutes = Math.round((end - start) / 60000);
    const hours = Math.floor(durationMinutes / 60);
    const minutes = Math.abs(durationMinutes % 60);
    this.durationOutputTarget.textContent = `Duration: ${hours}:${String(minutes).padStart(2, "0")} hours`;

    const valid = durationMinutes >= 60 && durationMinutes <= 1440;
    this.durationOutputTarget.classList.toggle(
      "preceptor-attendance__hint--danger",
      !valid
    );
    this.submitButtonTarget.disabled = !valid;
  }
}
